import { withPending, withRejected, withFulFilled } from './commons';
import { FETCH_ANSWERS } from '../actions/alternatives';

class PayloadMap {
  constructor(oldMap = null) {
    this.internalMap = new Map(oldMap);
  }

  get({ customerId, surveyId, questionId }) {
    const key = `${customerId}.${surveyId}.${questionId}`;
    return this.internalMap.get(key);
  }

  put({ customerId, surveyId, questionId }, alternatives) {
    const key = `${customerId}.${surveyId}.${questionId}`;
    return this.internalMap.set(key, alternatives);
  }

  toIterable() {
    return this.internalMap;
  }
}

// initial state
// key, values={running: bool, error: object, payload: alternativas*/)};
const INITIAL_STATE = new PayloadMap();

// executer
const execute = (state = INITIAL_STATE, action) => {
  // get old state
  const oldState = state;
  // create new state <-- esse procedimento procedimento garante mudança no useEffect
  const newState = new PayloadMap(oldState.toIterable());
  // update
  switch (action.type) {
  // alternatives
  case withPending(FETCH_ANSWERS):
    newState.put(action.meta, { running: true });
    return newState;
  case withRejected(FETCH_ANSWERS):
    newState.put(action.meta, { running: false, error: action.payload });
    return newState;
  case withFulFilled(FETCH_ANSWERS):
    newState.put(action.meta, { running: false, payload: action.payload.data });
    return newState;
    // nothing
  default:
    return state;
  }
};

export default execute;
